<template>
  <div>
    <DhGameTitle
      :tabItem="{ name: funTab.name, cover: funTab.cover, localName: funTab.localName }"
      :callback="onAllGames"
    />
    <div class="skeleton" v-if="isLoading">
      <div
        class="skeleton-big"
        :style="`background-image: url(${resBaseUrl}placeholder_img.png);`"
      />
      <div class="min-group">
        <div
          class="skeleton-min"
          :style="`background-image: url(${resBaseUrl}placeholder_img.png);`"
        />
        <div
          class="skeleton-min"
          :style="`background-image: url(${resBaseUrl}placeholder_img.png);`"
        />
      </div>
      <div class="min-group">
        <div
          class="skeleton-min"
          :style="`background-image: url(${resBaseUrl}placeholder_img.png);`"
        />
        <div
          class="skeleton-min"
          :style="`background-image: url(${resBaseUrl}placeholder_img.png);`"
        />
      </div>
    </div>
    <div v-else class="game-content">
      <div class="game" v-if="games.length > 0">
        <GameCard :game="games[0]" :isBig="true" style="margin-right: 0.05rem" />
        <div class="game-group">
          <GameCard :game="games[1]" height="2.43" />
          <GameCard :game="games[2]" height="2.43" style="margin-top: 0.1rem" />
        </div>
        <div class="game-group">
          <GameCard :game="games[3]" height="2.43" />
          <GameCard :game="games[4]" height="2.43" style="margin-top: 0.1rem" />
        </div>
      </div>
      <Empty v-else :callback="onReload" :hideRecommend="funTab.name != 'History'" />
    </div>
  </div>
</template>
<script>
import { useLobbyStore } from '@/stores/lobby'
import DhGameTitle from '@/components/GameTitle.vue'
import Empty from '@/components/Empty.vue'
import { mapActions, mapState } from 'pinia'
import { config } from '@/common/config'
import { useUserStore } from '@/stores/user'
import { splitText } from '@/utils/helper'
import GameCard from '@/components/GameCard.vue'
export default {
  name: 'DhGridGame',
  components: {
    DhGameTitle,
    Empty,
    GameCard
  },
  props: {
    funTab: {
      type: {},
      default: {}
    }
  },
  data() {
    return {
      isLoading: true,
      games: [],
      resBaseUrl: config.resBaseUrl
    }
  },
  computed: {
    ...mapState(useUserStore, ['isLogin'])
  },
  mounted() {
    this.onReload(true)
  },

  methods: {
    splitText,
    ...mapActions(useLobbyStore, {
      getGameList: 'getGameList',
      getBannersHomeTop: 'getBannersHomeTop',
      enterGame: 'enterGame'
    }),
    onAllGames() {
      this.$router.push({ name: 'allgame', params: { categorie: JSON.stringify(this.funTab) } })
    },
    getBackgroundColor(backColor) {
      var color = ''
      switch (backColor) {
        case 'G':
          color = 'gold-background-color'
          break
        case 'R':
          color = 'red-background-color'
          break
        case 'B':
          color = 'blue-background-color'
          break
        default:
          break
      }
      return color
    },
    onReload(isfirst = false) {
      if (isfirst || (!this.isLoading && this.funTab.id)) {
        this.isLoading = true
        this.getGameList(this.funTab.id, '', 1, 5)
          .then((response) => {
            this.games = response.games
          })
          .catch(() => {
            this.games = []
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.skeleton {
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  animation: blink 2s linear infinite;
  .skeleton-big {
    width: 39%;
    height: 4.94rem;
    background-color: #ffffff;
    border-radius: 17px 17px 17px 17px;
    margin-right: 5px;
  }
  .min-group {
    width: 30%;
    height: auto;
    margin-right: 5px;
    .skeleton-min {
      width: 100%;
      height: 2.44rem;
      background-color: #ffffff;
      border-radius: 17px 17px 17px 17px;
      margin-bottom: 5px;
    }
  }
}
.game-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // margin-bottom: 0.24rem;
  .game {
    display: flex;
    width: 100%;
    height: auto;
    justify-content: center;

    // .game-card {
    //   // display: flex;
    //   width: 39%;
    //   height: 4.34rem;
    //   background-size: 125%;
    //   background-repeat: no-repeat;
    //   background-position-x: 25%;
    //   border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
    //   margin-right: 0.1rem;
    //   margin-left: 0.1rem;

    //   .card {
    //     width: 100%;
    //     height: 100%;
    //     border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
    //     background-color: rgba(130, 92, 45, 1);
    //     float: left;
    //     // margin-top: -100%;
    //     margin-right: 0px;
    //     margin-bottom: 0px;
    //     margin-left: 0px;
    //     position: relative;
    //     // background: linear-gradient(
    //     //   to bottom,
    //     //   rgba(206, 180, 95, 0),
    //     //   rgba(206, 180, 95, 0) 70%,
    //     //   rgba(206, 180, 95, 0.6) 75%,
    //     //   rgba(206, 180, 95, 0.8) 80%,
    //     //   rgba(170, 136, 74, 0.9) 90%,
    //     //   rgba(130, 92, 45, 1) 95%
    //     // );

    //     .list_tab {
    //       font-size: 0.18rem;
    //       line-height: 0.24rem;
    //       color: #fff;
    //       text-align: center;
    //       height: auto;
    //       width: auto;
    //       padding-right: 0.1rem;
    //       padding-left: 0.1rem;
    //       border-radius: 0 0.1rem 0.1rem 0;
    //       float: left;
    //       position: absolute;
    //       z-index: 4;
    //       display: inline;
    //       box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.4);
    //     }

    //     .game-name {
    //       font-size: 0.4rem;
    //       line-height: 0.4rem;
    //       font-weight: 900;
    //       color: #fff;
    //       text-align: center;
    //       width: 94%;
    //       height: auto;
    //       bottom: 0px;
    //       position: absolute;
    //       margin-bottom: 0.35rem;
    //       padding: 0 3%;
    //       display: flex;
    //       text-shadow: 0 0 0.1rem rgba(0, 0, 0, 1);
    //       word-wrap: break-word;
    //       flex-direction: column-reverse;
    //       justify-content: flex-end;
    //     }

    //     .red_bg {
    //       background-color: #f00;
    //     }

    //     .green_bg {
    //       background-color: #00ab40;
    //     }

    //     .yellow_bg {
    //       background-color: #ffbe00;
    //     }
    //   }
    // }
    .game-group {
      width: 28.5%;
      height: auto;
      margin-right: 0.1rem;
      margin-left: 0.05rem;
      // .card-bg {
      //   width: 100%;
      //   height: 2.1rem;
      //   background-size: 100%;
      //   background-repeat: no-repeat;
      //   // background-position-x: 60%;
      //   border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
      //   margin-bottom: 5px;
      //   .min-card {
      //     width: 100%;
      //     height: 2.1rem;
      //     border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
      //     background-color: rgba(130, 92, 45, 1);
      //     float: left;
      //     // margin-top: -100%;
      //     margin-right: 0px;
      //     margin-bottom: 0px;
      //     margin-left: 0px;
      //     position: relative;
      //     // background: linear-gradient(
      //     //   to bottom,
      //     //   rgba(206, 180, 95, 0),
      //     //   rgba(206, 180, 95, 0) 70%,
      //     //   rgba(206, 180, 95, 0.6) 75%,
      //     //   rgba(206, 180, 95, 0.8) 80%,
      //     //   rgba(170, 136, 74, 0.9) 90%,
      //     //   rgba(130, 92, 45, 1) 95%
      //     // );

      //     .game-name {
      //       font-size: 0.33rem;
      //       line-height: 0.33rem;
      //       font-weight: 900;
      //       color: #fff;
      //       text-align: center;
      //       bottom: 0px;
      //       position: absolute;
      //       display: flex;
      //       width: 94%;
      //       height: auto;
      //       margin-bottom: 0.35rem;
      //       padding: 0 3%;
      //       text-shadow: 0 0 0.1rem rgba(0, 0, 0, 1);
      //       word-wrap: break-word;
      //       flex-direction: column-reverse;
      //       justify-content: flex-end;
      //     }
      //   }
      // }
    }
  }
  .game-active {
    display: flex;
    justify-content: space-between;
    margin: 0.2rem 0;
    padding: 0;
    height: auto;
    width: 100%;
    overflow: hidden;
    .active {
      margin: 0px;
      padding: 0px;
      width: 49%;
      height: 1rem;
      display: inline-block;
      border-radius: 0.16rem;
      overflow: hidden;
    }
  }
}

.gold-background-color-big {
  background: linear-gradient(
    to bottom,
    rgba(206, 180, 95, 0),
    rgba(206, 180, 95, 0.8) 35%,
    rgba(206, 180, 95, 1) 48%,
    rgba(170, 136, 74, 1) 70%,
    rgba(130, 92, 45, 1) 96%
  ) !important;
}

.red-background-color-big {
  background-color: rgba(213, 65, 0, 1);
  background: linear-gradient(
    to bottom,
    rgba(213, 65, 0, 0),
    rgba(213, 65, 0, 0.5) 30%,
    rgba(213, 65, 0, 1) 48%
  ) !important;
}

.blue-background-color-big {
  // background-color: rgba(213, 65, 0, 1);
  background: linear-gradient(
    to bottom,
    rgba(0, 63, 128, 0),
    rgba(0, 63, 128, 0.5) 30%,
    rgba(0, 63, 128, 1) 48%
  ) !important;
}

.gold-background-color {
  background: linear-gradient(
    to bottom,
    rgba(206, 180, 95, 0),
    rgba(206, 180, 95, 0) 70%,
    rgba(206, 180, 95, 0.6) 75%,
    rgba(206, 180, 95, 0.8) 80%,
    rgba(170, 136, 74, 0.9) 90%,
    rgba(130, 92, 45, 1) 95%
  ) !important;
}
.red-background-color {
  background-color: rgba(213, 65, 0, 1);
  background: linear-gradient(
    to bottom,
    rgba(213, 65, 0, 0),
    rgba(213, 65, 0, 0.6) 50%,
    rgba(213, 65, 0, 1) 95%
  ) !important;
}

.blue-background-color {
  background-color: rgba(0, 63, 128, 1);
  background: linear-gradient(
    to bottom,
    rgba(0, 63, 128, 0),
    rgba(0, 63, 128, 0.6) 50%,
    rgba(0, 63, 128, 1) 95%
  ) !important;
}

@keyframes blink {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0;
  }
}
</style>
